import { jsx } from "panel";
import { CheckboxEl } from "common/components/checkbox";
import { ButtonEl } from "common/components/button";
import { UserListEl } from "common/widgets/user-list";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { IconSizeType } from "common/constants";
import { InvitationStep } from "./constants";
import uberUrl from "./uber.png";
export function template() {
  const {
    formErrors,
    formValues,
    step,
    waitingForResponse
  } = this.state;
  const TermsOfUseCheckbox = () => /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row", style: {
    display: "flex"
  }, "data-sentry-component": "TermsOfUseCheckbox", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(CheckboxEl, { sel: ".signup-checkbox", attrs: {
    elref: "terms-of-use",
    checked: formValues.agreedToTermsOfUse
  }, on: {
    click: this.helpers.handleTermsOfUseCheckboxClick
  }, "data-sentry-element": "CheckboxEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-content" }, "Agreed to", /* @__PURE__ */ jsx("a", { attrs: {
    href: "/legal/terms-of-use/",
    class: "mp-link legal-link",
    target: "_blank"
  } }, "terms of use"), "and", /* @__PURE__ */ jsx("a", { attrs: {
    href: "/legal/privacy-policy/",
    class: "mp-link legal-link",
    target: "_blank"
  } }, "privacy statements"), ".", formErrors.agreedToTermsOfUse ? /* @__PURE__ */ jsx("div", { sel: ".auth-form-error-msg" }, formErrors.agreedToTermsOfUse) : null));
  const PromoCheckbox = (_ref) => {
    let {
      shouldShowCheckbox
    } = _ref;
    return shouldShowCheckbox ? /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row", style: {
      display: "inline-flex"
    } }, /* @__PURE__ */ jsx(CheckboxEl, { sel: ".signup-checkbox", attrs: {
      checked: formValues.agreedToEmailPromo
    }, on: {
      click: this.helpers.handleEmailPromoCheckboxClick
    } }), /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-content" }, "I want to understand every user\u2019s journey. Please email me about Mixpanel products and services so I can use data to grow my business. You can always opt out later. See our", /* @__PURE__ */ jsx("a", { attrs: {
      href: "/legal/marketing-privacy-notice/",
      class: "mp-link",
      target: "_blank"
    } }, "privacy policy"), "for more details.")) : null;
  };
  const SignupButton = (_ref2) => {
    let {
      disableBack,
      signupText = "Sign Up"
    } = _ref2;
    return /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row", "data-sentry-component": "SignupButton", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".auth-form-field-action-button", attrs: {
      elref: "sign-up-button",
      disabled: waitingForResponse,
      size: ButtonSize.Large,
      theme: ButtonTheme.Primary
    }, on: {
      click: this.helpers.handleSignup
    }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, signupText), !disableBack ? /* @__PURE__ */ jsx(ButtonEl, { sel: ".auth-form-field-action-button", attrs: {
      size: ButtonSize.Large,
      theme: ButtonTheme.Primary
    }, on: {
      click: this.helpers.handleBack
    } }, "Back") : null);
  };
  const SignInWithGoogle = () => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row" }, /* @__PURE__ */ jsx("div", { sel: "#g_id_onload.gid", attrs: {
    "data-client_id": this.helpers.getSignInWithGoogleClientId(),
    "data-callback": "handleGoogleCredentialResponse",
    "data-auto_prompt": "false"
  } }), /* @__PURE__ */ jsx("div", { sel: ".g_id_signin", attrs: {
    "data-type": "standard",
    "data-size": "large",
    "data-theme": "filled_blue",
    "data-text": "continue_with",
    "data-shape": "rectangular",
    "data-logo_alignment": "left",
    "data-width": 293
  } })), /* @__PURE__ */ jsx("div", { sel: ".auth-form-divider" }, /* @__PURE__ */ jsx("div", { sel: ".auth-form-divider-content" }, "or sign up with email")));
  const AlreadyAUserFooter = (_ref3) => {
    let {
      next
    } = _ref3;
    const nextParam = next ? "?next=".concat(encodeURIComponent(next)) : "";
    return /* @__PURE__ */ jsx("div", { sel: ".auth-form-footer", "data-sentry-component": "AlreadyAUserFooter", "data-sentry-source-file": "template.tsx" }, "Already a user?", /* @__PURE__ */ jsx("a", { attrs: {
      href: "/login/".concat(nextParam),
      class: "mp-link"
    }, style: {
      "padding-left": "5px"
    } }, "Log in."));
  };
  const ConfirmMagicLink = () => {
    const email = formValues.email;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".auth-form-copy-content.center" }, "We sent a verification email to"), /* @__PURE__ */ jsx("div", { sel: ".auth-form-copy-content-bold.center" }, email));
  };
  const ResendMagicLinkFooter = () => /* @__PURE__ */ jsx("div", { sel: ".auth-form-footer", on: {
    click: this.helpers.sendRegistrationMagicLink
  }, "data-sentry-component": "ResendMagicLinkFooter", "data-sentry-source-file": "template.tsx" }, "Not seeing the email?", /* @__PURE__ */ jsx("a", { attrs: {
    class: "mp-link"
  }, style: {
    "padding-left": "5px"
  } }, "Resend"));
  return /* @__PURE__ */ jsx("form", { attrs: {
    name: "signup",
    id: "signup-invited"
  }, on: {
    submit: this.helpers.handleFormSent
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, step === InvitationStep.Default ? /* @__PURE__ */ jsx(null, null, this.attr("is-uber") ? /* @__PURE__ */ jsx("div", { sel: ".company-logo" }, /* @__PURE__ */ jsx("img", { attrs: {
    src: uberUrl
  } })) : null, /* @__PURE__ */ jsx("h1", { sel: ".auth-form-title.center" }, "Join Your Team"), /* @__PURE__ */ jsx("div", { sel: ".auth-form-subtitle.center" }, "Welcome to ", formValues.company, "\u2019s org."), /* @__PURE__ */ jsx("div", { sel: ".auth-form-subtitle.center" }, formValues.email, " \u{1F642}"), /* @__PURE__ */ jsx(UserListEl, { attrs: {
    "max-icons-displayed": 4,
    users: this.attr("users-preview") || [],
    "more-text": "team members",
    "user-count-override": this.attr("users-total"),
    size: IconSizeType.Small,
    "style-override": ".more-text { font-size: 14px; } .users-list { justify-content: center; }"
  } }), /* @__PURE__ */ jsx(SignInWithGoogle, null), /* @__PURE__ */ jsx(TermsOfUseCheckbox, null), /* @__PURE__ */ jsx(PromoCheckbox, { shouldShowCheckbox: this.attr("is-gdpr") }), /* @__PURE__ */ jsx(SignupButton, { disableBack: true, signupText: "Join Team" }), /* @__PURE__ */ jsx(AlreadyAUserFooter, { next: this.attr("next") })) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ConfirmMagicLink, null), /* @__PURE__ */ jsx(ResendMagicLinkFooter, null)));
}
